import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { hasRole } from "@/js/http/auth.js";
import { formRules } from "@/js/form_rules.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { listContinents } from "@/js/lists.ts";
import address from "@/components/address/Address.vue";
import confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  components: {
    addressStorage: address,
    confirm: confirm,
    ErrorModal: ErrorModal
  },
  props: {
    id: Number,
    items: [],
    countries: [],
    states: []
  },
  data: function data(_this) {
    return {
      isSaving: false,
      isApplyingToStock: false,
      form: {
        valid: false
      },
      managedExceptions: {
        warning: {
          migrate_consignments_stock_used_in_order: "An existing stock is used in a cart, or in an order in progress. It may cause shipping or cost issues. This action is impossible."
        }
      },
      selectedItems: [],
      dialog: false,
      dialogDelete: false,
      headers: [{
        text: "Name",
        value: "name"
      }, {
        text: "Country",
        value: "address.country.printable_name"
      }, {
        text: "Continent",
        value: "continent"
      }, {
        text: "Default storage for producer",
        value: "isDefaultStorage",
        align: "center"
      }, {
        text: "Actions",
        value: "actions"
      }],
      editedItem: {
        technical_front_id: 0,
        id: 0,
        name: "",
        address: {},
        isDefaultStorage: false
      },
      defaultItem: {},
      applyStockCancellationToken: null,
      listContinents: listContinents,
      rules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    canManage: function canManage() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_STOCK);
    },
    formTitle: function formTitle() {
      return this.editedItem.id ? "Edit storage address" : "New storage address";
    }
  },
  created: function created() {
    this.defaultItem = _objectSpread(_objectSpread({}, this.editedItem), {}, {
      address: {}
    });
    this.selectedItems = _toConsumableArray(this.items);
  },
  watch: {
    dialog: function dialog(val) {
      if (!val) {
        this.close();
      } else {
        if (this.editedItem && !this.editedItem.isBeingEdited) {
          this.editedItem.isBeingEdited = false;
        }
      }
    },
    dialogDelete: function dialogDelete(val) {
      val || this.closeDelete();
    }
  },
  methods: {
    editItem: function editItem(item) {
      this.editedItem = _objectSpread(_objectSpread({}, item), {}, {
        isBeingEdited: true
      });
      this.dialog = true;
    },
    deleteItem: function deleteItem(item) {
      this.editedItem = item;
      this.dialogDelete = true;
    },
    deleteItemConfirm: function deleteItemConfirm() {
      this.selectedItems.splice(this.selectedItems.indexOf(this.editedItem), 1);
      this.closeDelete();
      this.$emit("save", this.selectedItems);
    },
    defineEuropeWarehouseAsDefaultStorage: function defineEuropeWarehouseAsDefaultStorage() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this, response, warehouse;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this = _this2;
              _context.next = 3;
              return request("/v1/warehouse/defaults-departures/EU/", "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load europe warehouse.");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 3:
              response = _context.sent;
              warehouse = _objectSpread({}, response.data.value);
              _this2.editedItem = {
                name: warehouse.name,
                isDefaultStorage: true,
                address: _objectSpread({}, warehouse.address)
              };
              _this2.save();
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    close: function close() {
      var _this3 = this;
      this.dialog = false;
      this.$nextTick(function () {
        _this3.editedItem = _objectSpread(_objectSpread({}, _this3.defaultItem), {}, {
          address: {}
        });
      });
    },
    closeDelete: function closeDelete() {
      var _this4 = this;
      this.dialogDelete = false;
      this.$nextTick(function () {
        _this4.editedItem = _objectSpread(_objectSpread({}, _this4.defaultItem), {}, {
          address: {}
        });
      });
    },
    save: function save() {
      var _this5 = this;
      this.isSaving = true;
      var itemToSave = _objectSpread({}, this.editedItem);
      if (!itemToSave.isBeingEdited) {
        if (this.selectedItems.length > 0) {
          var minIdNegative = Math.min.apply(Math, _toConsumableArray(this.selectedItems.map(function (x) {
            return x.technical_front_id;
          })));
          itemToSave.technical_front_id = minIdNegative - 1;
        } else {
          itemToSave.technical_front_id = -1;
        }
      }
      if (itemToSave.isDefaultStorage && this.selectedItems.length > 0) {
        this.selectedItems.forEach(function (x) {
          x.isDefaultStorage = false;
        });
      }
      delete itemToSave.isBeingEdited;
      if (!!this.editedItem.isBeingEdited) {
        var editedIndex = this.selectedItems.findIndex(function (x) {
          return x.technical_front_id == _this5.editedItem.technical_front_id;
        });
        this.selectedItems.splice(editedIndex, 1, itemToSave);
      } else {
        this.selectedItems = [].concat(_toConsumableArray(this.selectedItems), [itemToSave]);
      }
      this.close();
      this.editedItem = _objectSpread(_objectSpread({}, this.defaultItem), {}, {
        address: {}
      });
      this.$emit("save", this.selectedItems);
      this.isSaving = false;
    },
    applyToStocks: function applyToStocks(addressId) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var confirmed, _this$applyStockCance, _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this6.$refs.confirm.open("Cnnfirm", "Are you sure you want to move all existing direct stocks of this producer to this storage location ?", {
                color: "red"
              });
            case 2:
              confirmed = _context2.sent;
              if (!confirmed) {
                _context2.next = 9;
                break;
              }
              _this = _this6;
              (_this$applyStockCance = _this.applyStockCancellationToken) === null || _this$applyStockCance === void 0 || _this$applyStockCance.cancel();
              _this.applyStockCancellationToken = axios.CancelToken.source();
              _this.isApplyingToStock = true;
              return _context2.abrupt("return", request("/v1/producers/" + _this6.id + "/consignments/all/storage-locations", "put", {
                addressId: addressId
              }, true, "api", null, _this.applyStockCancellationToken).then(function (_) {
                _this.isApplyingToStock = false;
                _this.$toasted.show("Storage location applied to existing direct stocks", {
                  type: "success"
                });
              }).catch(function (e) {
                _this.isApplyingToStock = false;
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              }));
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};